import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import BottomPageSelectorWithPagination, {
  usePagination,
} from "components/common/BottomPageSelectorWithPagination";
import List from "components/common/ListWithMoreOptions";
import usePriceLists from "graphql/usePriceLists";
import useWindowSize from "useWindowSize";
import { useMessaging } from "context/MessagingContext";
import usePriceListMutations from "graphql/usePriceListMutations";
import { usePaginatedData } from "helpers/hooks";

// const createDefaultPriceList = (items, t) => {
//   const itemsMap = items.map((item) => ({
//     itemId: item._id,
//     price: item.price,
//     _id: new BSON.ObjectId().toString(),
//   }));

//   return {
//     _id: "default",
//     name: t("containers.InventoryPriceList.defaultPriceList"),
//     items: itemsMap,
//     updateDatetime: new Date().toISOString(),
//     creationDatetime: new Date().toISOString(),
//   };
// };

const ListTable = ({ setItemToEdit, setAddItemModalOpen, search }) => {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const { deletePriceList } = usePriceListMutations();
  const { setConfirmMessage, setErrorMessage } = useMessaging();

  const { sorting, setSorting, pagination, setPagination } =
    usePagination("name");

  const { priceLists } = usePriceLists();

  // const defaultPriceList = useMemo(
  //   () => createDefaultPriceList(items, t),
  //   [items, t]
  // );

  // const newPriceLists = useMemo(
  //   () => [defaultPriceList, ...priceLists],
  //   [defaultPriceList, priceLists]
  // );

  const data = useMemo(() => {
    const searchLower = search.toLocaleLowerCase();
    return priceLists.filter((priceList) =>
      priceList.name.toLocaleLowerCase().includes(searchLower)
    );
  }, [search, priceLists]);

  const dataToShow = usePaginatedData(data, pagination, sorting, (item) => {
    return [item.name, moment(item.updateDatetime).format("lll")];
  });

  const columns = useMemo(
    () => [
      {
        title: t("containers.InventoryPriceList.nameList"),
        sortable: true,
        columnId: "name",
      },
      {
        title: t("containers.InventoryPriceList.InventoryPriceList"),
        sortable: true,
        columnId: "updateDatetime",
      },
      { title: "" },
    ],
    [t]
  );

  const columnWidths = `${Array(columns.length - 1)
    .fill(width <= 990 ? "6fr" : "10fr")
    .join(" ")} 7fr`;

  const onDeleteRequest = useCallback(
    (list) => {
      setConfirmMessage({
        titleAlert: t("containers.InventoryPriceList.delete"),
        confirm1: `${t("containers.InventoryPriceList.deleteList")} ${
          list.name
        }? `,
        confirm2: t("containers.InventoryPriceList.actionCannotBeUndone"),
        onConfirm: () =>
          deletePriceList(list).catch((e) => setErrorMessage({ error: e })),
      });
    },
    [deletePriceList, setConfirmMessage, setErrorMessage, t]
  );

  return (
    <>
      <List
        width={650}
        handleEdit={(list) => {
          const copy = JSON.parse(JSON.stringify(list.element));
          function cleanCopy(copy) {
            delete copy.__typename;
            copy.items?.forEach((list) => {
              delete list.__typename;
            });
          }
          cleanCopy(copy);
          setItemToEdit(copy);
          setAddItemModalOpen(true);
        }}
        handleDeleteWorker={(category) => onDeleteRequest(category.element)}
        data={dataToShow}
        columns={columns}
        sorting={sorting}
        moreOption={true}
        changeSorting={(columnId, order) => setSorting({ columnId, order })}
        tableStyle={{ gridTemplateColumns: columnWidths }}
      />
      <BottomPageSelectorWithPagination
        pagination={pagination}
        setPagination={setPagination}
        length={data.length}
      />
    </>
  );
};

export default ListTable;
